// Reel frame themes — mirrors pipeline/reels/frame_themes.py. Keep the ids
// identical across both so the UI can pass a theme id straight to
// story_reels.frame_theme, which pipeline/reels/job_worker.py reads.
//
// Unlike POSTER_THEMES (a color palette fed into an image-gen prompt), each
// entry here points at an actual ornate-frame PNG asset. Twelve ship today
// so a week's reels don't all look alike; the pipeline rotates through them
// via frame_themes.rotate_frame_theme() unless a theme is picked here.

export const REEL_FRAME_THEMES = [
  {
    id: "ornate-gold",
    name: "Ornate Gold — Classical Kathakala",
    tagline: "Gold border, navy card",
    swatch: "#C9A84C",
  },
  {
    id: "palm-leaf",
    name: "Palm-Leaf Manuscript — తాళపత్ర",
    tagline: "Aged sepia manuscript edges",
    swatch: "#8B6F47",
  },
  {
    id: "kalamkari",
    name: "Kalamkari Block-Print — కలంకారీ",
    tagline: "Indigo & rust hand-block",
    swatch: "#1F3A5F",
  },
  {
    id: "temple-stone",
    name: "Temple Stone — గోపురం",
    tagline: "Carved granite gopuram relief",
    swatch: "#6E6A63",
  },
  {
    id: "kuchipudi-silk",
    name: "Kuchipudi Silk — పట్టు",
    tagline: "Crimson silk with gold zari",
    swatch: "#9B1B30",
  },
  {
    id: "peacock",
    name: "Peacock — నెమలి",
    tagline: "Emerald & teal feather eyes",
    swatch: "#12776B",
  },
  {
    id: "marigold",
    name: "Marigold Festive — బంతిపూలు",
    tagline: "Marigold & jasmine garlands",
    swatch: "#E8871E",
  },
  {
    id: "veena-raga",
    name: "Veena & Raga — వీణ",
    tagline: "Brass instruments & notation",
    swatch: "#B07A2A",
  },
  {
    id: "midnight-lotus",
    name: "Midnight Lotus — నీలకమలం",
    tagline: "Indigo night, silver lotus",
    swatch: "#1A2B5F",
  },
  {
    id: "terracotta",
    name: "Terracotta Folk — మట్టి కళ",
    tagline: "Earthy Cheriyal folk relief",
    swatch: "#A0522D",
  },
  {
    id: "jasmine-pearl",
    name: "Jasmine & Pearl — మల్లె",
    tagline: "Ivory, pearl & jasmine",
    swatch: "#EDE4D3",
  },
  {
    id: "bronze-deepam",
    name: "Bronze Deepam — దీపం",
    tagline: "Antique bronze & lamp glow",
    swatch: "#6B4A2F",
  },
];

export const DEFAULT_REEL_FRAME_THEME_ID = "ornate-gold";

export function getReelFrameTheme(id) {
  return REEL_FRAME_THEMES.find((t) => t.id === id) || null;
}
